import { MembershipTypes } from '@/enums/member'

export const getSignupUrl = ({ membershipTypeReference, designSlug }: { membershipTypeReference: string, designSlug: string }) => {
  if (designSlug && membershipTypeReference === MembershipTypes.menOriginals) {
    return `/men/signup/men-originals/${designSlug}`
  }

  if (designSlug && membershipTypeReference === MembershipTypes.menOne) {
    return `/men/signup/men-one/${designSlug}`
  }

  return '/men/signup/choose-design'
}
